import Http from 'axios'
import {API_URL, VERSION, VERSIONED_API_URL} from '../../../config/config'
import {
    APPROVE_VISA_TRANSFER,
    CHECK_VISA_TRANSFER_PAYMENT_STATUS,
    GENERATE_TRANSFER_VOUCHER,
    GET_VISA_TRANSFER,
    REJECT_VISA_TRANSFER,
    SAVE_VISA_TRANSFER_TIPPANI,
    VERIFY_TRANSFER_CERTIFICATION,
    PRINT_VISA_TRANSFER
} from "../../action-type";
import {SET_TRANSFER_DATA, SET_TRANSFER_TIPPANI_PRINT_CONTENT, SET_TRANSFER_VOUCHER_NUMBER} from "../../mutation-type";

function initialState() {
    return {
        transferDetail: {
            transfer_data: [],
            traveller: [],
            visa: [],
            id: null
        },
        tippaniContent: null,
        approveData: {},
        rejectData: {}
    }
}

const getters = {
    transferDetail: state => state.transferDetail,
    approveData: state => state.approveData,
    tippaniContent: state => state.tippaniContent,
    rejectData: state => state.rejectData
};

const actions = {
    [GET_VISA_TRANSFER]({commit}, transfer_id) {
        return new Promise(((resolve, reject) => {
            Http.get(`${API_URL}${VERSION}/visa-transfers/` + transfer_id).then((res) => {
                commit(SET_TRANSFER_DATA, res.data.data);
                resolve(true)
            })
        }));
    },
    [CHECK_VISA_TRANSFER_PAYMENT_STATUS]({dispatch, state}, transfer_no) {
        return new Promise(((resolve, reject) => {
            Http.put(`${API_URL}${VERSION}/visa-transfers/payment-status/` + transfer_no).then((res) => {
                dispatch(GET_VISA_TRANSFER, state.transferDetail.id);
                resolve(res)
            }).catch((err) => {
                reject(err)
            })
        }));
    },
    async [GENERATE_TRANSFER_VOUCHER]({commit, state}) {
        try {
            const response = await Http.post(`${VERSIONED_API_URL}/generate-track-voucher/` + state.transferDetail.submission_no);
            commit(SET_TRANSFER_VOUCHER_NUMBER, response.data.data.voucher_number);
            return response.data;
        } catch (e) {
            throw  e;
        }

    },
    async [SAVE_VISA_TRANSFER_TIPPANI]({state, dispatch}, tippani_content) {

        try {
            await Http.put(`${API_URL}${VERSION}/visa-transfers/` + state.transferDetail.submission_no, {content: tippani_content})
            dispatch(GET_VISA_TRANSFER, state.transferDetail.id);

        } catch (e) {
            throw e;
        }

    },
    [APPROVE_VISA_TRANSFER]({state, commit}) {
        let formData = new FormData();
        let files = state.approveData.files;
        if (files !== undefined) {
            for (let i = 0; i < files.length; i++) {
                formData.append(`files[${i}]`, files[i]);
            }
        }
        formData.set('remarks', state.approveData.remarks);
        return new Promise(((resolve, reject) => {
            Http.post(`${API_URL}${VERSION}/visa-transfers/approve/` + state.transferDetail.submission_no, formData).then((res) => {
                resolve(true)
            }).catch((err) => {
                reject(err)
            })
        }));
    },
    [PRINT_VISA_TRANSFER]({state, commit}) {
        return new Promise(((resolve, reject) => {
            Http.post(`${API_URL}${VERSION}/visa-transfers/print/` + state.transferDetail.submission_no).then((res) => {
                resolve(true)
            }).catch((err) => {
                reject(err)
            })
        }));
    },
    [REJECT_VISA_TRANSFER]({state, commit}) {
        let formData = new FormData();
        let files = state.rejectData.files;
        let file = state.rejectData.file;
        if(file)
            formData.append("file", file);
        if(files)
            for (let i = 0; i < files.length; i++)
                formData.append(`files[${i}]`, files[i]);

        formData.set('remarks', state.rejectData.remarks);
        return new Promise(((resolve, reject) => {
            Http.post(`${API_URL}${VERSION}/visa-transfers/reject/` + state.transferDetail.submission_no, formData).then((res) => {
                resolve(true)
            }).catch((err) => {
                reject(err)
            })
        }));
    },
    async [VERIFY_TRANSFER_CERTIFICATION]({dispatch, state}, data) {
        const formData = new FormData();
        formData.append('file', data.file);
        try {
            return await Http.post(`${API_URL}${VERSION}/visa-transfers/verify/` + state.transferDetail.submission_no, formData);
        } catch (e) {
            throw e;
        }
    },
};

const mutations = {
        [SET_TRANSFER_DATA](state, transferDetail) {
            state.transferDetail = transferDetail;
        },
        [SET_TRANSFER_TIPPANI_PRINT_CONTENT](state, tippani) {
            state.tippaniContent = tippani;
        },
        [SET_TRANSFER_VOUCHER_NUMBER](state, voucher_number) {
            state.transferDetail.voucher_number = voucher_number;
            state.transferDetail.voucher_generated = true;
        }
    }
;

export default {
    state: initialState,
    getters,
    actions,
    mutations
}
